<div class="optional_container">
  <ng-content></ng-content>
</div>
